module.exports = __webpack_public_path__ + "static/img/weibo.4ca8eb2.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/aboutUs/imgs/weibo.jpeg
// module id = ZtZF
// module chunks = 1